import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';




const DeleteAccountPage = () => {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>
      <div style={{ maxWidth: '42rem', width: '100%', backgroundColor: 'white', borderRadius: '0.75rem', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', padding: '2rem' }}>
        <h1 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: '#111827', marginBottom: '0.5rem' }}>
          Delete Your Account
        </h1>
        <p style={{ fontSize: '1.125rem', color: '#4b5563', marginBottom: '2rem' }}>
          This page explains how to request deletion of your account and associated data for the{' '}
          <span style={{ fontWeight: '600', color: '#4f46e5' }}>Enerbeast app</span>.
        </p>

        <div style={{ backgroundColor: '#eef2ff', borderLeft: '4px solid #6366f1', padding: '1rem', marginBottom: '2rem' }}>
          <p style={{ color: '#374151', fontWeight: '500' }}>
            Please email us at{' '}
            <a href="mailto:myronixiottech@hotmail.com" style={{ color: '#4f46e5', textDecoration: 'underline', fontWeight: '600' }}>
              myronixiottech@hotmail.com
            </a>{' '}
            with your registered email and subject line{' '}
            <span style={{ backgroundColor: 'white', padding: '0.125rem 0.5rem', borderRadius: '0.25rem', color: '#4338ca', fontFamily: 'monospace', fontSize: '0.875rem' }}>
              Account Deletion Request
            </span>
            .
          </p>
          <p style={{ color: '#4b5563', marginTop: '0.75rem', fontSize: '0.875rem' }}>
            If you want your information removed partially, specify what to remove (e.g., consumption, history, payment
            history, usage history, etc.) and send it to the mail address above.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem', marginBottom: '2rem' }}>
          <div>
            <h2 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#111827', marginBottom: '0.75rem', display: 'flex', alignItems: 'center' }}>
              <svg style={{ width: '1.25rem', height: '1.25rem', color: '#ef4444', marginRight: '0.5rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              Data That Will Be Deleted
            </h2>
            <ul style={{ listStyle: 'none', padding: 0, color: '#374151' }}>
              <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
                <span style={{ color: '#ef4444', marginRight: '0.5rem' }}>•</span>
                User profile (name, email, payment info)
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
                <span style={{ color: '#ef4444', marginRight: '0.5rem' }}>•</span>
                App activity and usage data
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start' }}>
                <span style={{ color: '#ef4444', marginRight: '0.5rem' }}>•</span>
                Saved preferences and settings
              </li>
            </ul>
          </div>

          <div>
            <h2 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#111827', marginBottom: '0.75rem', display: 'flex', alignItems: 'center' }}>
              <svg style={{ width: '1.25rem', height: '1.25rem', color: '#3b82f6', marginRight: '0.5rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Data Retention
            </h2>
            <p style={{ color: '#374151' }}>
              All user-related data will be permanently deleted within{' '}
              <span style={{ fontWeight: '600' }}>30 days</span> of receiving a verified deletion request, unless legally
              required to retain it for longer.
            </p>
          </div>
        </div>

        <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '1.5rem', textAlign: 'center', fontSize: '0.875rem', color: '#6b7280' }}>
          Enerbeast App · Data Deletion Policy
        </div>
      </div>
    </div>
  );
};

 
const SupportPage = () => {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>
      <div style={{ maxWidth: '42rem', width: '100%', backgroundColor: 'white', borderRadius: '0.75rem', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', padding: '2rem' }}>
        <h1 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: '#111827', marginBottom: '0.5rem', display: 'flex', alignItems: 'center' }}>
          <svg style={{ width: '2rem', height: '2rem', color: '#4f46e5', marginRight: '0.75rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636a9 9 0 010 12.728m0 0a9 9 0 01-12.728 0m12.728 0A9 9 0 015.636 5.636m12.728 0A9 9 0 015.636 18.364M12 8v4l3 3m-3-7a1 1 0 110-2 1 1 0 010 2z" />
          </svg>
          Contact Support
        </h1>
        <p style={{ fontSize: '1.125rem', color: '#4b5563', marginBottom: '2rem' }}>
          We're here to help! Reach out to us through any of the channels below.
        </p>

         
        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '1.5rem', marginBottom: '2rem' }}>
          
          <div style={{ 
            backgroundColor: '#f3f4f6', 
            borderRadius: '0.5rem', 
            padding: '1.25rem',
            borderLeft: '4px solid #4f46e5'
          }}>
            <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#111827', marginBottom: '0.5rem', display: 'flex', alignItems: 'center' }}>
              <svg style={{ width: '1.25rem', height: '1.25rem', color: '#4f46e5', marginRight: '0.5rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Email
            </h2>
            <a href="mailto:myronixiottech@hotmail.com" style={{ 
              color: '#4f46e5', 
              textDecoration: 'underline',
              fontSize: '1.125rem',
              fontWeight: '500'
            }}>
              myronixiottech@hotmail.com
            </a>
            <p style={{ color: '#6b7280', fontSize: '0.875rem', marginTop: '0.5rem' }}>
              We typically respond within 24-48 hours
            </p>
          </div>

          
          <div style={{ 
            backgroundColor: '#f3f4f6', 
            borderRadius: '0.5rem', 
            padding: '1.25rem',
            borderLeft: '4px solid #10b981'
          }}>
            <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#111827', marginBottom: '0.5rem', display: 'flex', alignItems: 'center' }}>
              <svg style={{ width: '1.25rem', height: '1.25rem', color: '#10b981', marginRight: '0.5rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              Phone
            </h2>
            <a href="tel:9851234396" style={{ 
              color: '#111827', 
              textDecoration: 'none',
              fontSize: '1.125rem',
              fontWeight: '500'
            }}>
              9851234396
            </a>
            <p style={{ color: '#6b7280', fontSize: '0.875rem', marginTop: '0.5rem' }}>
              Available Monday-Friday, 9 AM - 6 PM NPT
            </p>
          </div>

      
          <div style={{ 
            backgroundColor: '#f3f4f6', 
            borderRadius: '0.5rem', 
            padding: '1.25rem',
            borderLeft: '4px solid #8b5cf6'
          }}>
            <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#111827', marginBottom: '0.5rem', display: 'flex', alignItems: 'center' }}>
              <svg style={{ width: '1.25rem', height: '1.25rem', color: '#8b5cf6', marginRight: '0.5rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              Office Address
            </h2>
            <p style={{ 
              color: '#111827', 
              fontSize: '1.125rem',
              fontWeight: '500',
              marginBottom: '0.5rem'
            }}>
              Bhaisepati-25, Lalitpur, Nepal
            </p>
            <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
              Visit us during business hours
            </p>
          </div>
        </div>

     
        <div style={{ 
          backgroundColor: '#eef2ff', 
          borderLeft: '4px solid #6366f1', 
          padding: '1.5rem',
          borderRadius: '0.5rem',
          marginBottom: '1.5rem'
        }}>
          <h3 style={{ fontWeight: '600', color: '#1e293b', marginBottom: '0.5rem' }}>
            For App Issues & Feedback
          </h3>
          <p style={{ color: '#334155', fontSize: '0.95rem' }}>
            For general app issues, feature enhancement requests, or feedback, please contact us via email or phone. 
            We value your input and strive to improve the Enerbeast experience.
          </p>
        </div>

      
        <div style={{ 
          borderTop: '1px solid #e5e7eb', 
          paddingTop: '1.5rem', 
          textAlign: 'center', 
          fontSize: '0.875rem', 
          color: '#6b7280'
        }}>
          <p>Enerbeast App · Support Page</p>
          <p style={{ marginTop: '0.5rem', fontSize: '0.75rem' }}>
            For account deletion requests, please visit the <Link to="/" style={{ color: '#4f46e5', textDecoration: 'underline' }}>Delete Account</Link> page.
          </p>
        </div>
      </div>
    </div>
  );
};

const PaymentSuccessPage = () => {
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(to bottom right, #f0fdf4, #d1fae5)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>
      <div style={{ marginBottom: '2rem' }}>
        <svg style={{ width: '5rem', height: '5rem', color: '#22c55e' }} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
      </div>
      <h1 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '0.5rem' }}>
        Payment Successful
      </h1>
      <p style={{ fontSize: '1.125rem', color: '#4b5563' }}>Thank you for your payment.</p>
    </div>
  );
};

const PaymentFailurePage = () => {
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(to bottom right, #fef2f2, #ffe4e6)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>
      <div style={{ marginBottom: '2rem' }}>
        <svg style={{ width: '5rem', height: '5rem', color: '#ef4444' }} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
        </svg>
      </div>
      <h1 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '0.5rem' }}>
        Payment Failed
      </h1>
      <p style={{ fontSize: '1.125rem', color: '#4b5563' }}>Something went wrong. Please try again.</p>
    </div>
  );
};

 
const App = () => {
  return (
    <Router>
      
      <Routes>
        <Route path="/" element={<DeleteAccountPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/success" element={<PaymentSuccessPage />} />
        <Route path="/failure" element={<PaymentFailurePage />} />
        <Route path="*" element={<DeleteAccountPage />} />
      </Routes>
    </Router>
  );
};

export default App;